module.exports = __webpack_public_path__ + "img/header-16.ea6625e.png";